import { useEffect, useRef, useState } from 'react'
import { Box } from '@mui/material'

// Draggable divider that controls the LEGEND panel's width, mirrored from the
// Network Overview module (Beacon4 App > LegendResizeHandle). The legend sits on
// the right edge, so dragging the handle LEFT grows it and RIGHT shrinks it.
// Double-click resets to the default. Shared by the main dashboard (App) and the
// maximised chart window (ChartModal).

export const LEGEND_MIN_W     = 160
export const LEGEND_MAX_W     = 460
export const LEGEND_DEFAULT_W = 220

export function LegendResizeHandle({ onResize, onReset }) {
  const draggingRef = useRef(false)
  const lastXRef    = useRef(0)
  const [dragging, setDragging] = useState(false)

  useEffect(() => {
    const onMouseMove = (e) => {
      if (!draggingRef.current) return
      const delta = e.clientX - lastXRef.current
      lastXRef.current = e.clientX
      onResize(w => Math.min(LEGEND_MAX_W, Math.max(LEGEND_MIN_W, w - delta)))
    }
    const onMouseUp = () => {
      if (!draggingRef.current) return
      draggingRef.current = false
      setDragging(false)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }
    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
    return () => {
      window.removeEventListener('mousemove', onMouseMove)
      window.removeEventListener('mouseup', onMouseUp)
    }
  }, [onResize])

  const onMouseDown = (e) => {
    draggingRef.current = true
    setDragging(true)
    lastXRef.current = e.clientX
    document.body.style.cursor = 'col-resize'
    document.body.style.userSelect = 'none'
  }

  return (
    <Box
      onMouseDown={onMouseDown}
      onDoubleClick={onReset}
      title="Drag to resize legend · double-click to reset"
      sx={{
        flexShrink: 0,
        width: 6,
        cursor: 'col-resize',
        bgcolor: dragging ? 'grey.400' : 'grey.200',
        '&:hover': { bgcolor: 'grey.400' },
      }}
    />
  )
}
